import {useLayoutEffect} from 'react'

const PROPERTY='--hubbing-forum-navigation-height'

// The fixed navigation already includes the device safe area in its measured
// height. Reserve that exact amount in the forum's real scrolling box.
export default function useForumScrollClearance({active,identity,scrollRef,navigationRef}) {
  useLayoutEffect(()=>{
    const scroll=scrollRef.current,navigation=navigationRef.current
    if(!active||!scroll||!navigation)return undefined
    const previous=scroll.style.getPropertyValue(PROPERTY)
    const priority=scroll.style.getPropertyPriority(PROPERTY)
    let current=true
    const measure=()=>{
      if(!current)return
      const height=navigation.getBoundingClientRect().height
      if(!Number.isFinite(height)||height<=0)return
      const value=`${Math.ceil(height)}px`
      if(scroll.style.getPropertyValue(PROPERTY)!==value)scroll.style.setProperty(PROPERTY,value)
    }
    const observer=typeof ResizeObserver==='function'?new ResizeObserver(measure):null
    observer?.observe(navigation)
    window.addEventListener('resize',measure)
    window.visualViewport?.addEventListener('resize',measure)
    measure()
    return()=>{
      current=false
      observer?.disconnect()
      window.removeEventListener('resize',measure)
      window.visualViewport?.removeEventListener('resize',measure)
      if(previous)scroll.style.setProperty(PROPERTY,previous,priority)
      else scroll.style.removeProperty(PROPERTY)
    }
  },[active,identity,scrollRef,navigationRef])
}
